import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';

/** returns a ref which is stateful so that when it is set, it will cause a render */
export const useRefState = initialState => {
  const $ = _c(5);
  const [el, setEl] = useState(initialState);
  let t0;
  if ($[0] !== el) {
    t0 = e => {
      if (e && !el) {
        setEl(e);
      }
    };
    $[0] = el;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onRef = t0;
  let t1;
  if ($[2] !== el || $[3] !== onRef) {
    t1 = {
      ref: onRef,
      element: el
    };
    $[2] = el;
    $[3] = onRef;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};